import React, { Component } from 'react';
import PropTypes from 'prop-types';
import move from 'lodash-move';
import isNumber from 'lodash/isNumber';
import throttle from 'lodash/throttle';
import { MdArrowForward } from 'react-icons/md';

import Flex from '../../Flex';
import Box from '../../Box';

import Option from './Option';
import DraggableOption from './DraggableOption';
import TargetBox from './TargetBox';
import BorderBox from './BorderBox';

const dummyEle = (
  <Box
    key="dummy"
    height="2em"
    border="1px dashed"
    borderColor="gray"
    pointerEvents="none"
  />
);

class DragSort extends Component {
  constructor(props) {
    super(props);
    const { options } = props;
    this.flavoredOptions = options.map((opt, value) => ({
      ...opt,
      value,
    }));
    // this.optionWidth = (Math.max(...options.map((opt) => opt.length)) + 3) + 'em';
    const { value } = props;
    this.state = {
      sorted: value || []
    }
    this.handleHover = throttle(this.handleHover, 500);
  }

  handleDrop = (value, pos, direction) => {
    const { sorted } = this.state;
    if (!sorted.includes(value)) {
      // sorted.splice(pos + direction, 0, value)
      sorted.push(value)
      this.setState({ sorted });
    }
  }

  handelMove = (index, targetIndex) => {
    const { sorted } = this.state;
    this.setState({
      sorted: move(sorted, index, targetIndex),
      dummy: null,
    });
  }

  handleDragEnd = () => this.setState({ dummy: null }, this.handleOnChange)

  handleHover = (index, direction) => this.setState({ dummy: index + direction })

  handleOnChange = () => {
    const { sorted } = this.state;
    const { onChange, name } = this.props;
    if (onChange) {
      onChange({
        target: {
          value: sorted,
          name,
        },
        persist: () => {},
      });
    }
  }

  handleCancel = (index) => () => {
    const { sorted } = this.state;
    sorted.splice(index, 1);
    this.setState({
      sorted,
    }, this.handleOnChange);
  }

  render() {
    const {
      label,
      options,
      randomID,
      field,
      form,
      required,
      name,
      onChange,
      onBlur,
      value,
      values,
      readOnly,
      disabled,
      ...props
    } = this.props;
    const { sorted, dummy } = this.state;
    let inBoxOptions = sorted.map((value, index) => readOnly ? (
      <Option
        key={value}
        value={value}
        index={index}
        inBox
        {...options[value]}
      />
    ) : (
      <DraggableOption
        key={value}
        value={value}
        index={index}
        onHover={this.handleHover}
        onMove={this.handelMove}
        onDragEnd={this.handleDragEnd}
        onCancel={this.handleCancel(index)}
        inBox
        {...options[value]}
      />
    ));
    const hasDummy = isNumber(dummy);
    if (hasDummy) {
      if (dummy === sorted.length) {
        inBoxOptions.push(dummyEle);
      } else {
        inBoxOptions = inBoxOptions.reduce((withDummy, opt, index) => {
          if (dummy === index) {
            return withDummy.concat([
              dummyEle,
              opt,
            ])
          } else {
            return withDummy.concat(opt);
          }
        }, []);
      }
    }
    return (
      <Box {...props}>
        <Flex position="relative" px="0.5em" my="1em">
          <BorderBox flex={1} label="選項">
            {this.flavoredOptions.filter((opt) => !sorted.includes(opt.value)).map((opt) => readOnly ? (
              <Option
                key={opt.value}
                value={opt.value}
                {...opt}
              />
            ) : (
              <DraggableOption
                key={opt.value}
                value={opt.value}
                onDragEnd={this.handleDragEnd}
                onDrop={this.handleDrop}
                {...opt}
              />
            ))}
          </BorderBox>
          <Box mx="1em" py="1em" fontSize="1.5em">
            <MdArrowForward />
          </Box>
          <BorderBox flex={1} label="排序">
            <TargetBox onMove={this.handelMove}>
              {inBoxOptions}
            </TargetBox>
          </BorderBox>
        </Flex>
      </Box>
    );
  }
}

DragSort.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
  })).isRequired,
};

export default DragSort;
